/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SignUp/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import CreateAccount from './CreateAccount/index'
import Email from './Email/index'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import Info from 'DesignSystem/Info/index'
import Instructions from './Instructions/index'
import OnboardingInfoDesktop from 'DesignSystem/OnboardingInfoDesktop/index'
import React from 'react'
import TysiaTextLink from 'DesignSystem/TysiaTextLink/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import useIsMedia from 'Simple/hooks/useIsMedia'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function SignUp({
  children,
  viewPath = "/App/Auth/SignUp"
  
}) {
  let isBefore = useIsBefore()
  let isMedia = useIsMedia()
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
/>
<div
  data-testid="SignUp.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="SignUp.Vertical"
  data-view-path={viewPath}
 style={{'--o-2-Z29l7Sf': isBefore ? 0 : 1,'--w-1-Z29l7Sf': isMedia.mobile ? "100%" : "50%"}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="SignUp.Vertical:1"
  data-view-path={viewPath}
 style={{'--w-1-Z29l7Sf': isMedia.mobile ? "340px" : "360px"}}
 className={`views-block ${styles.Vertical1}`}
>
<Instructions
  viewPath={`${viewPath}/Instructions`}
/>
<Email
  viewPath={`${viewPath}/Email`}
/>
<CreateAccount
  viewPath={`${viewPath}/CreateAccount`}
/>
<div
  data-testid="SignUp.Horizontal:1"
  data-view-path={viewPath}
 style={{'--btc-3-Z29l7Sf': dtColorsNeutral400}}
 className={`views-block ${styles.Horizontal1}`}
>
<Info
  viewPath={`${viewPath}/Info`}
 text="By signing in I agree to"
 marginRight={dtSpaceXxs}
 marginTop={dtSpaceS}
/>
<TysiaTextLink
  viewPath={`${viewPath}/TysiaTextLink`}
 text="Terms of Use"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../TermsAndConditions'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../TermsAndConditions'))}
/>
</div>
<div
  data-testid="SignUp.Horizontal:2"
  data-view-path={viewPath}
 style={{'--mt-4-Z29l7Sf': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal2}`}
>
<Info
  viewPath={`${viewPath}/Info`}
 text="Have an account?"
 marginRight={dtSpaceXxs}
/>
<TysiaTextLink
  viewPath={`${viewPath}/TysiaTextLink`}
 text="Go to sign in"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../SignIn'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../SignIn'))}
/>
</div>
</div>
</div>
<fromFlow.When is={!isMedia.mobile}>
<OnboardingInfoDesktop
  viewPath={`${viewPath}/OnboardingInfoDesktop`}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}